export const delegatesMock = {
  "data": [
      {
          "rank": 1,
          "delegateAddress": "0x5e349eca2dc61abcd9dd99ce94d04136151a09ee",
          "ensName": "lindaxie.eth",
          "numberOfDelegators": 864,
          "votingPower": 63089.556296101575,
          "totalVotes": 80,
          "votes1Year": 0,
          "votes6Months": 0,
          "votes3Months": 0,
          "gScoreRank": 222
      },
      {
          "rank": 2,
          "delegateAddress": "0x34aa3f359a9d614239015126635ce7732c18fdf3",
          "ensName": "austingriffith.eth",
          "numberOfDelegators": 631,
          "votingPower": 43366.15786668542,
          "totalVotes": 31,
          "votes1Year": 0,
          "votes6Months": 0,
          "votes3Months": 0,
          "gScoreRank": 50170
      },
      {
          "rank": 3,
          "delegateAddress": "0x2b888954421b424c5d3d9ce9bb67c9bd47537d12",
          "ensName": "lefteris.eth",
          "numberOfDelegators": 362,
          "votingPower": 111750.61482711532,
          "totalVotes": 89,
          "votes1Year": 0,
          "votes6Months": 0,
          "votes3Months": 0,
          "gScoreRank": 358
      },
      {
          "rank": 4,
          "delegateAddress": "0xa30ab83e693ad49f3f651085dad11d049c818923",
          "ensName": "anneconnelly.eth",
          "numberOfDelegators": 325,
          "votingPower": 12886.579980803182,
          "totalVotes": 28,
          "votes1Year": 0,
          "votes6Months": 0,
          "votes3Months": 0,
          "gScoreRank": 165944
      },
      {
          "rank": 5,
          "delegateAddress": "0x71553df14efe2708bf16734aab821af239a24d3b",
          "ensName": null,
          "numberOfDelegators": 275,
          "votingPower": 6844.127031336108,
          "totalVotes": 4,
          "votes1Year": 0,
          "votes6Months": 0,
          "votes3Months": 0,
          "gScoreRank": 930601
      },
      {
          "rank": 6,
          "delegateAddress": "0x73186b2a81952c2340c4eb2e74e89869e1183df0",
          "ensName": "amyjung.eth",
          "numberOfDelegators": 260,
          "votingPower": 6019.800337376509,
          "totalVotes": 6,
          "votes1Year": 0,
          "votes6Months": 0,
          "votes3Months": 0,
          "gScoreRank": 163334
      },
      {
          "rank": 7,
          "delegateAddress": "0x02eb89d2ff910989024e19673f8302a695bbd979",
          "ensName": "yellow.niran.eth",
          "numberOfDelegators": 258,
          "votingPower": 14052.21290329589,
          "totalVotes": 2,
          "votes1Year": 0,
          "votes6Months": 0,
          "votes3Months": 0,
          "gScoreRank": 767386
      },
      {
          "rank": 8,
          "delegateAddress": "0x54becc7560a7be76d72ed76a1f5fee6c5a2a7ab6",
          "ensName": "simona.eth",
          "numberOfDelegators": 256,
          "votingPower": 46168.18232063013,
          "totalVotes": 68,
          "votes1Year": 0,
          "votes6Months": 0,
          "votes3Months": 0,
          "gScoreRank": 4394
      },
      {
          "rank": 9,
          "delegateAddress": "0x839395e20bbb182fa440d08f850e6c7a8f6f0780",
          "ensName": "griff.eth",
          "numberOfDelegators": 247,
          "votingPower": 19245.41354328992,
          "totalVotes": 147,
          "votes1Year": 22,
          "votes6Months": 11,
          "votes3Months": 5,
          "gScoreRank": 118
      },
      {
          "rank": 10,
          "delegateAddress": "0xc2e2b715d9e302947ec7e312fd2384b5a1296099",
          "ensName": "kbw.eth",
          "numberOfDelegators": 222,
          "votingPower": 484105.5291650313,
          "totalVotes": 173,
          "votes1Year": 21,
          "votes6Months": 7,
          "votes3Months": 2,
          "gScoreRank": 8899
      },
      {
          "rank": 11,
          "delegateAddress": "0xa2bf1b0a7e079767b4701b5a1d9d5700eb42d1d1",
          "ensName": "kennethng.eth",
          "numberOfDelegators": 217,
          "votingPower": 8906.130716590846,
          "totalVotes": 8,
          "votes1Year": 0,
          "votes6Months": 0,
          "votes3Months": 0,
          "gScoreRank": 107475
      },
      {
          "rank": 12,
          "delegateAddress": "0xc3fab4228ce462653dbf0bb3e4f3fdd81697fec4",
          "ensName": null,
          "numberOfDelegators": 216,
          "votingPower": 1306.5316668982766,
          "totalVotes": 4,
          "votes1Year": 0,
          "votes6Months": 0,
          "votes3Months": 0,
          "gScoreRank": 745910
      },
      {
          "rank": 13,
          "delegateAddress": "0x86d3ee9ff0983bc33b93cc8983371a500f873446",
          "ensName": "androolloyd.eth",
          "numberOfDelegators": 211,
          "votingPower": 4627.264804154062,
          "totalVotes": 11,
          "votes1Year": 0,
          "votes6Months": 0,
          "votes3Months": 0,
          "gScoreRank": 155641
      },
      {
          "rank": 14,
          "delegateAddress": "0xd23aff9ad562c445bcab03321cbfe63bf4b0bcf2",
          "ensName": null,
          "numberOfDelegators": 205,
          "votingPower": 2327.365085307617,
          "totalVotes": 0,
          "votes1Year": 0,
          "votes6Months": 0,
          "votes3Months": 0,
          "gScoreRank": 1133098
      },
      {
          "rank": 15,
          "delegateAddress": "0x4c0a466df0628fe8699051b3ac6506653191cc21",
          "ensName": "trent.eth",
          "numberOfDelegators": 197,
          "votingPower": 41745.285018006834,
          "totalVotes": 18,
          "votes1Year": 0,
          "votes6Months": 0,
          "votes3Months": 0,
          "gScoreRank": 144697
      },
      {
          "rank": 16,
          "delegateAddress": "0x6375885ce997543cc7e057fe9af3e255d52fb4f4",
          "ensName": "ntnsndr.eth",
          "numberOfDelegators": 193,
          "votingPower": 6556.273159215724,
          "totalVotes": 2,
          "votes1Year": 0,
          "votes6Months": 0,
          "votes3Months": 0,
          "gScoreRank": 767386
      },
      {
          "rank": 17,
          "delegateAddress": "0xf503017d7baf7fbc0fff7492b751025c6a78179b",
          "ensName": "trueblocks.eth",
          "numberOfDelegators": 182,
          "votingPower": 5155.809082544959,
          "totalVotes": 57,
          "votes1Year": 0,
          "votes6Months": 0,
          "votes3Months": 0,
          "gScoreRank": 71759
      },
      {
          "rank": 18,
          "delegateAddress": "0x66b1de0f14a0ce971f7f248415063d44caf19398",
          "ensName": "yalor.eth",
          "numberOfDelegators": 165,
          "votingPower": 23191.999513896437,
          "totalVotes": 19,
          "votes1Year": 3,
          "votes6Months": 0,
          "votes3Months": 0,
          "gScoreRank": 2214
      },
      {
          "rank": 19,
          "delegateAddress": "0xcf88fa6ee6d111b04be9b06ef6fad6bd6691b88c",
          "ensName": "jordanlyall.eth",
          "numberOfDelegators": 163,
          "votingPower": 1616.1405674775533,
          "totalVotes": 4,
          "votes1Year": 0,
          "votes6Months": 0,
          "votes3Months": 0,
          "gScoreRank": 69215
      },
      {
          "rank": 20,
          "delegateAddress": "0xdc0046b52e2e38aee2271b6171ebb65ccd337518",
          "ensName": "adamstallard.eth",
          "numberOfDelegators": 160,
          "votingPower": 680.7146250094602,
          "totalVotes": 8,
          "votes1Year": 0,
          "votes6Months": 0,
          "votes3Months": 0,
          "gScoreRank": 181112
      },
      {
          "rank": 21,
          "delegateAddress": "0x10d6d2e343281d388291a3e02f3293aaeda67178",
          "ensName": "helloshreyas.eth",
          "numberOfDelegators": 158,
          "votingPower": 2391.0325393255202,
          "totalVotes": 50,
          "votes1Year": 0,
          "votes6Months": 0,
          "votes3Months": 0,
          "gScoreRank": 32094
      },
      {
          "rank": 22,
          "delegateAddress": "0xd9ffaf2e880df0cc7b7104e9e789d281a81824cf",
          "ensName": null,
          "numberOfDelegators": 157,
          "votingPower": 38226.301863730754,
          "totalVotes": 32,
          "votes1Year": 0,
          "votes6Months": 0,
          "votes3Months": 0,
          "gScoreRank": 135017
      },
      {
          "rank": 23,
          "delegateAddress": "0x80d63799b1e08a80f73fb7a83264b5c31600bf3a",
          "ensName": "hudson.eth",
          "numberOfDelegators": 153,
          "votingPower": 47897.516873769775,
          "totalVotes": 18,
          "votes1Year": 1,
          "votes6Months": 0,
          "votes3Months": 0,
          "gScoreRank": 189869
      },
      {
          "rank": 24,
          "delegateAddress": "0x16d2ad8cc04888b537bb7b631715335a901b57ca",
          "ensName": "planett.eth",
          "numberOfDelegators": 150,
          "votingPower": 4807.288019214256,
          "totalVotes": 7,
          "votes1Year": 0,
          "votes6Months": 0,
          "votes3Months": 0,
          "gScoreRank": 1034424
      },
      {
          "rank": 25,
          "delegateAddress": "0x2d407ddb06311396fe14d4b49da5f0471447d45c",
          "ensName": "andrecronje.eth",
          "numberOfDelegators": 148,
          "votingPower": 3699.1397179959495,
          "totalVotes": 3,
          "votes1Year": 0,
          "votes6Months": 0,
          "votes3Months": 0,
          "gScoreRank": 141717
      },
      {
          "rank": 26,
          "delegateAddress": "0x016c8780e5ccb32e5caa342a926794ce64d9c364",
          "ensName": "anish.eth",
          "numberOfDelegators": 143,
          "votingPower": 1056.9668068551296,
          "totalVotes": 5,
          "votes1Year": 0,
          "votes6Months": 0,
          "votes3Months": 0,
          "gScoreRank": 872803
      },
      {
          "rank": 27,
          "delegateAddress": "0xf4c7e772f24c10e3ce60ce549059a021f60c911e",
          "ensName": "decibels42.eth",
          "numberOfDelegators": 142,
          "votingPower": 2869.4977886010033,
          "totalVotes": 12,
          "votes1Year": 0,
          "votes6Months": 0,
          "votes3Months": 0,
          "gScoreRank": 539973
      },
      {
          "rank": 28,
          "delegateAddress": "0x4be88f63f919324210ea3a2ccad4ff0734425f91",
          "ensName": "kevinolsen.eth",
          "numberOfDelegators": 139,
          "votingPower": 2278.612788815217,
          "totalVotes": 52,
          "votes1Year": 0,
          "votes6Months": 0,
          "votes3Months": 0,
          "gScoreRank": 109128
      },
      {
          "rank": 29,
          "delegateAddress": "0x3ec44a823e07555b5f889d8d954eec736eb5865b",
          "ensName": "uevguy.eth",
          "numberOfDelegators": 138,
          "votingPower": 602.9584092100729,
          "totalVotes": 48,
          "votes1Year": 0,
          "votes6Months": 0,
          "votes3Months": 0,
          "gScoreRank": 91158
      },
      {
          "rank": 30,
          "delegateAddress": "0x554c5af96e9e3c05aec01ce18221d0dd25975ab4",
          "ensName": "zak.eth",
          "numberOfDelegators": 129,
          "votingPower": 1695.793583715223,
          "totalVotes": 3,
          "votes1Year": 0,
          "votes6Months": 0,
          "votes3Months": 0,
          "gScoreRank": 471764
      },
      {
          "rank": 31,
          "delegateAddress": "0x88cca876eebb2a541ed87584f189319c3441aca6",
          "ensName": null,
          "numberOfDelegators": 127,
          "votingPower": 2314.348692785745,
          "totalVotes": 18,
          "votes1Year": 0,
          "votes6Months": 0,
          "votes3Months": 0,
          "gScoreRank": 936946
      },
      {
          "rank": 32,
          "delegateAddress": "0x8b405dbf2f30844b608b08dad20447a6955a6c6e",
          "ensName": null,
          "numberOfDelegators": 122,
          "votingPower": 19054.850562152293,
          "totalVotes": 1,
          "votes1Year": 0,
          "votes6Months": 0,
          "votes3Months": 0,
          "gScoreRank": 2075966
      },
      {
          "rank": 33,
          "delegateAddress": "0x8d07d225a769b7af3a923481e1fdf49180e6a265",
          "ensName": "monetsupply.eth",
          "numberOfDelegators": 114,
          "votingPower": 970.9716618355226,
          "totalVotes": 71,
          "votes1Year": 0,
          "votes6Months": 0,
          "votes3Months": 0,
          "gScoreRank": 293
      },
      {
          "rank": 34,
          "delegateAddress": "0x6bf1eba9740441d0a8822eda4e116a74f850d81b",
          "ensName": "phutchins.eth",
          "numberOfDelegators": 113,
          "votingPower": 186.11774089461161,
          "totalVotes": 26,
          "votes1Year": 0,
          "votes6Months": 0,
          "votes3Months": 0,
          "gScoreRank": 370252
      },
      {
          "rank": 35,
          "delegateAddress": "0x31482858561725b74b5ec2a739e447bc74cdf7b9",
          "ensName": "andy.thebluebook.eth",
          "numberOfDelegators": 112,
          "votingPower": 2982.4797882766165,
          "totalVotes": 5,
          "votes1Year": 0,
          "votes6Months": 0,
          "votes3Months": 0,
          "gScoreRank": 1780689
      },
      {
          "rank": 36,
          "delegateAddress": "0xf3fe8c6c75be4afb2f8200fc77339abe4d7cff33",
          "ensName": "kuiqian.eth",
          "numberOfDelegators": 110,
          "votingPower": 540.7405000000001,
          "totalVotes": 0,
          "votes1Year": 0,
          "votes6Months": 0,
          "votes3Months": 0,
          "gScoreRank": 144
      },
      {
          "rank": 37,
          "delegateAddress": "0x5a384227b65fa093dec03ec34e111db80a040615",
          "ensName": "matoken.eth",
          "numberOfDelegators": 95,
          "votingPower": 7458.874587595015,
          "totalVotes": 3,
          "votes1Year": 0,
          "votes6Months": 0,
          "votes3Months": 0,
          "gScoreRank": 98867
      },
      {
          "rank": 38,
          "delegateAddress": "0x4bc519f0b7b348fae780afb2dd4aa76841ba8e9e",
          "ensName": null,
          "numberOfDelegators": 95,
          "votingPower": 1282.4016144217542,
          "totalVotes": 8,
          "votes1Year": 0,
          "votes6Months": 0,
          "votes3Months": 0,
          "gScoreRank": 508639
      },
      {
          "rank": 39,
          "delegateAddress": "0xf07a2439296e07bc4320af924e655a01fb69d89c",
          "ensName": "adamscochran.eth",
          "numberOfDelegators": 94,
          "votingPower": 3364.043184295742,
          "totalVotes": 2,
          "votes1Year": 0,
          "votes6Months": 0,
          "votes3Months": 0,
          "gScoreRank": 7693
      },
      {
          "rank": 40,
          "delegateAddress": "0xc7e6bbf6dbe78b40640385e73dc1958f4428fb3e",
          "ensName": "tobyshorin.eth",
          "numberOfDelegators": 93,
          "votingPower": 538.364251427683,
          "totalVotes": 13,
          "votes1Year": 0,
          "votes6Months": 0,
          "votes3Months": 0,
          "gScoreRank": 949270
      },
      {
          "rank": 41,
          "delegateAddress": "0x9600e2ee6377dadad7299b120026661c336a5e6d",
          "ensName": "azeemkhan.eth",
          "numberOfDelegators": 93,
          "votingPower": 184.19111373705172,
          "totalVotes": 53,
          "votes1Year": 0,
          "votes6Months": 0,
          "votes3Months": 0,
          "gScoreRank": 57247
      },
      {
          "rank": 42,
          "delegateAddress": "0x58f123bd4261ea25955b362be57d89f4b6e7110a",
          "ensName": "aaronsoskin.eth",
          "numberOfDelegators": 75,
          "votingPower": 2815.1745540028137,
          "totalVotes": 1,
          "votes1Year": 0,
          "votes6Months": 0,
          "votes3Months": 0,
          "gScoreRank": 233025
      },
      {
          "rank": 43,
          "delegateAddress": "0x4f0a1940de411285ad0455a7f40c81b5e0bc8492",
          "ensName": "jujuba.eth",
          "numberOfDelegators": 74,
          "votingPower": 9184.058131458936,
          "totalVotes": 0,
          "votes1Year": 0,
          "votes6Months": 0,
          "votes3Months": 0,
          "gScoreRank": 39507
      },
      {
          "rank": 44,
          "delegateAddress": "0x5ba02f4ff6af1d9d2af8774d10fd32eb57d4e2e6",
          "ensName": "p1anck.eth",
          "numberOfDelegators": 74,
          "votingPower": 816.2711896997723,
          "totalVotes": 8,
          "votes1Year": 0,
          "votes6Months": 0,
          "votes3Months": 0,
          "gScoreRank": 579240
      },
      {
          "rank": 45,
          "delegateAddress": "0x2273ec459c89aaf64c0c289a8c864170f7dd88ba",
          "ensName": "4eth.eth",
          "numberOfDelegators": 74,
          "votingPower": 7.450000000000001,
          "totalVotes": 6,
          "votes1Year": 0,
          "votes6Months": 0,
          "votes3Months": 0,
          "gScoreRank": 48075
      },
      {
          "rank": 46,
          "delegateAddress": "0x224e69025a2f705c8f31efb6694398f8fd09ac5c",
          "ensName": "chrismartz.eth",
          "numberOfDelegators": 70,
          "votingPower": 912.0471134799207,
          "totalVotes": 26,
          "votes1Year": 0,
          "votes6Months": 0,
          "votes3Months": 0,
          "gScoreRank": 50453
      },
      {
          "rank": 47,
          "delegateAddress": "0xb53b0255895c4f9e3a185e484e5b674bccfbc076",
          "ensName": "peth.eth",
          "numberOfDelegators": 69,
          "votingPower": 2079.858362421682,
          "totalVotes": 1,
          "votes1Year": 0,
          "votes6Months": 0,
          "votes3Months": 0,
          "gScoreRank": 179774
      },
      {
          "rank": 48,
          "delegateAddress": "0x3b067af83f540cb827825a6ee5480441a4237e77",
          "ensName": "conectopia.eth",
          "numberOfDelegators": 66,
          "votingPower": 1247.819099998,
          "totalVotes": 4,
          "votes1Year": 0,
          "votes6Months": 0,
          "votes3Months": 0,
          "gScoreRank": 1076493
      },
      {
          "rank": 49,
          "delegateAddress": "0xb0623c91c65621df716ab8afe5f66656b21a9108",
          "ensName": "johnpalmer.eth",
          "numberOfDelegators": 64,
          "votingPower": 333.5450531354672,
          "totalVotes": 1,
          "votes1Year": 0,
          "votes6Months": 0,
          "votes3Months": 0,
          "gScoreRank": 39961
      },
      {
          "rank": 50,
          "delegateAddress": "0xf93f0b770784602fc3079eb1d2fb1ff488bb02b0",
          "ensName": "viriya.eth",
          "numberOfDelegators": 57,
          "votingPower": 2381.243007842411,
          "totalVotes": 76,
          "votes1Year": 0,
          "votes6Months": 0,
          "votes3Months": 0,
          "gScoreRank": 101766
      },
      {
          "rank": 51,
          "delegateAddress": "0x934b510d4c9103e6a87aef13b816fb080286d649",
          "ensName": "sujiyan.eth",
          "numberOfDelegators": 56,
          "votingPower": 2178.3299157137462,
          "totalVotes": 5,
          "votes1Year": 0,
          "votes6Months": 0,
          "votes3Months": 0,
          "gScoreRank": 262507
      },
      {
          "rank": 52,
          "delegateAddress": "0x7221b104fba7701084759fd25faca19ac6300855",
          "ensName": "paller.eth",
          "numberOfDelegators": 53,
          "votingPower": 4188.601765833657,
          "totalVotes": 0,
          "votes1Year": 0,
          "votes6Months": 0,
          "votes3Months": 0,
          "gScoreRank": 1443391
      },
      {
          "rank": 53,
          "delegateAddress": "0x77d40c87d423efb7ec576e80998a48377adf86df",
          "ensName": null,
          "numberOfDelegators": 47,
          "votingPower": 78.55580288271409,
          "totalVotes": 2,
          "votes1Year": 0,
          "votes6Months": 0,
          "votes3Months": 0,
          "gScoreRank": 1286831
      },
      {
          "rank": 54,
          "delegateAddress": "0x5a5d9ab7b1bd978f80909503ebb828879daca9c3",
          "ensName": "cerv1.eth",
          "numberOfDelegators": 45,
          "votingPower": 1450440.5100166507,
          "totalVotes": 113,
          "votes1Year": 18,
          "votes6Months": 7,
          "votes3Months": 2,
          "gScoreRank": 11718
      },
      {
          "rank": 55,
          "delegateAddress": "0xabf28f8d9adfb2255f4a059e37d3bce9104969db",
          "ensName": "meglister.eth",
          "numberOfDelegators": 41,
          "votingPower": 75.7610426436727,
          "totalVotes": 77,
          "votes1Year": 19,
          "votes6Months": 2,
          "votes3Months": 0,
          "gScoreRank": 40856
      },
      {
          "rank": 56,
          "delegateAddress": "0x60c3677554c66554b65a08dbf6e5f0bba5e283a3",
          "ensName": null,
          "numberOfDelegators": 39,
          "votingPower": 0,
          "totalVotes": 0,
          "votes1Year": 0,
          "votes6Months": 0,
          "votes3Months": 0,
          "gScoreRank": null
      },
      {
          "rank": 57,
          "delegateAddress": "0xb35659cbac913d5e4119f2af47fd490a45e2c826",
          "ensName": "eventhorizoncommunity.eth",
          "numberOfDelegators": 38,
          "votingPower": 152255.31454285118,
          "totalVotes": 16,
          "votes1Year": 9,
          "votes6Months": 4,
          "votes3Months": 0,
          "gScoreRank": 1273
      },
      {
          "rank": 58,
          "delegateAddress": "0x8f48282e50b0210bd7c7dd69c54205e98b9ef5d9",
          "ensName": "coachj.eth",
          "numberOfDelegators": 38,
          "votingPower": 122.66402902002879,
          "totalVotes": 68,
          "votes1Year": 0,
          "votes6Months": 0,
          "votes3Months": 0,
          "gScoreRank": 39457
      },
      {
          "rank": 59,
          "delegateAddress": "0x01cf9fd2efa5fdf178bd635c3e2adf25b2052712",
          "ensName": "disruptionjoe.eth",
          "numberOfDelegators": 36,
          "votingPower": 112.20484274275029,
          "totalVotes": 87,
          "votes1Year": 0,
          "votes6Months": 0,
          "votes3Months": 0,
          "gScoreRank": 5267
      },
      {
          "rank": 60,
          "delegateAddress": "0x17e3f802e098dc5cc2a9d36e49f98b3171bbf0cd",
          "ensName": null,
          "numberOfDelegators": 35,
          "votingPower": 856.9028338859109,
          "totalVotes": 6,
          "votes1Year": 0,
          "votes6Months": 0,
          "votes3Months": 0,
          "gScoreRank": 1517621
      },
      {
          "rank": 61,
          "delegateAddress": "0x05a1ff0a32bc24265bcb39499d0c5d9a6cb2011c",
          "ensName": "willywonka.eth",
          "numberOfDelegators": 35,
          "votingPower": 421.6547009990005,
          "totalVotes": 12,
          "votes1Year": 0,
          "votes6Months": 0,
          "votes3Months": 0,
          "gScoreRank": 3175
      },
      {
          "rank": 62,
          "delegateAddress": "0x7289f29d4ad1e6607f7cfd85da288f123eec07ef",
          "ensName": null,
          "numberOfDelegators": 34,
          "votingPower": 0,
          "totalVotes": 0,
          "votes1Year": 0,
          "votes6Months": 0,
          "votes3Months": 0,
          "gScoreRank": 1703934
      },
      {
          "rank": 63,
          "delegateAddress": "0xfe7bcb3676aabe9a6b39cb23f3a5fa41eed7ad1b",
          "ensName": "raullen.eth",
          "numberOfDelegators": 32,
          "votingPower": 97.5045025773672,
          "totalVotes": 0,
          "votes1Year": 0,
          "votes6Months": 0,
          "votes3Months": 0,
          "gScoreRank": 1208635
      },
      {
          "rank": 64,
          "delegateAddress": "0x7e052ef7b4bb7e5a45f331128afadb1e589deaf1",
          "ensName": "kris.eth",
          "numberOfDelegators": 31,
          "votingPower": 23577.2418363036,
          "totalVotes": 86,
          "votes1Year": 2,
          "votes6Months": 1,
          "votes3Months": 1,
          "gScoreRank": 44068
      },
      {
          "rank": 65,
          "delegateAddress": "0xa7499aa6464c078eeb940da2fc95c6acd010c3cc",
          "ensName": "bneiluj.eth",
          "numberOfDelegators": 31,
          "votingPower": 398.950399999,
          "totalVotes": 0,
          "votes1Year": 0,
          "votes6Months": 0,
          "votes3Months": 0,
          "gScoreRank": 248823
      },
      {
          "rank": 66,
          "delegateAddress": "0x35efa46f22e0fb34cd8cb3ddf87149140d444b7c",
          "ensName": null,
          "numberOfDelegators": 28,
          "votingPower": 55.546212792133765,
          "totalVotes": 5,
          "votes1Year": 0,
          "votes6Months": 0,
          "votes3Months": 0,
          "gScoreRank": 399348
      },
      {
          "rank": 67,
          "delegateAddress": "0xb41077b88ff9e42355fc2ffeaa1810560ac5f192",
          "ensName": "heynate.eth",
          "numberOfDelegators": 28,
          "votingPower": 14.858773678473938,
          "totalVotes": 65,
          "votes1Year": 0,
          "votes6Months": 0,
          "votes3Months": 0,
          "gScoreRank": 124445
      },
      {
          "rank": 68,
          "delegateAddress": "0x9da7b7c89b170f50178faaf90ea41966757d9f2a",
          "ensName": null,
          "numberOfDelegators": 28,
          "votingPower": 0,
          "totalVotes": 0,
          "votes1Year": 0,
          "votes6Months": 0,
          "votes3Months": 0,
          "gScoreRank": 2115628
      },
      {
          "rank": 69,
          "delegateAddress": "0xe4b420f15d6d878dcd0df7120ac0fc1509ee9cab",
          "ensName": "bybus.eth",
          "numberOfDelegators": 27,
          "votingPower": 4644.006067038513,
          "totalVotes": 9,
          "votes1Year": 1,
          "votes6Months": 0,
          "votes3Months": 0,
          "gScoreRank": 118586
      },
      {
          "rank": 70,
          "delegateAddress": "0xb39d022edf05c31e1981f4f4d8137dda9c57cfae",
          "ensName": "jbradach.eth",
          "numberOfDelegators": 27,
          "votingPower": 510.269175127731,
          "totalVotes": 79,
          "votes1Year": 1,
          "votes6Months": 0,
          "votes3Months": 0,
          "gScoreRank": 4869
      },
      {
          "rank": 71,
          "delegateAddress": "0x98fe6b33eb2ecf7875b3010879bfea9d6c4cacec",
          "ensName": null,
          "numberOfDelegators": 27,
          "votingPower": 363.08856461999994,
          "totalVotes": 0,
          "votes1Year": 0,
          "votes6Months": 0,
          "votes3Months": 0,
          "gScoreRank": null
      },
      {
          "rank": 72,
          "delegateAddress": "0xf4b0556b9b6f53e00a1fdd2b0478ce841991d8fa",
          "ensName": "olimpio.eth",
          "numberOfDelegators": 26,
          "votingPower": 339.9513039279363,
          "totalVotes": 0,
          "votes1Year": 0,
          "votes6Months": 0,
          "votes3Months": 0,
          "gScoreRank": 4
      },
      {
          "rank": 73,
          "delegateAddress": "0xb215cfebb90d91b1d2f499843800d3105b1366fc",
          "ensName": "erick.eth",
          "numberOfDelegators": 25,
          "votingPower": 103.846099999,
          "totalVotes": 0,
          "votes1Year": 0,
          "votes6Months": 0,
          "votes3Months": 0,
          "gScoreRank": 471904
      },
      {
          "rank": 74,
          "delegateAddress": "0x2df9a188fbe231b0dc36d14aceb65defbb049479",
          "ensName": "janineleger.eth",
          "numberOfDelegators": 24,
          "votingPower": 31383.08307542293,
          "totalVotes": 22,
          "votes1Year": 0,
          "votes6Months": 0,
          "votes3Months": 0,
          "gScoreRank": 284982
      },
      {
          "rank": 75,
          "delegateAddress": "0x9ac9c636404c8d46d9eb966d7179983ba5a3941a",
          "ensName": "typto.eth",
          "numberOfDelegators": 24,
          "votingPower": 89.16137759575744,
          "totalVotes": 1,
          "votes1Year": 0,
          "votes6Months": 0,
          "votes3Months": 0,
          "gScoreRank": 34493
      },
      {
          "rank": 76,
          "delegateAddress": "0x31227a723bcce92432827a8c839f783e7149fc60",
          "ensName": "marksc.eth",
          "numberOfDelegators": 23,
          "votingPower": 1132.9764007645967,
          "totalVotes": 0,
          "votes1Year": 0,
          "votes6Months": 0,
          "votes3Months": 0,
          "gScoreRank": 2563584
      },
      {
          "rank": 77,
          "delegateAddress": "0x521aacb43d89e1b8ffd64d9ef76b0a1074dedaf8",
          "ensName": "bobjiang.eth",
          "numberOfDelegators": 22,
          "votingPower": 1618.8194067089805,
          "totalVotes": 93,
          "votes1Year": 0,
          "votes6Months": 0,
          "votes3Months": 0,
          "gScoreRank": 26821
      },
      {
          "rank": 78,
          "delegateAddress": "0x8d00a28992b491759517df8144b85abeea2a6d54",
          "ensName": null,
          "numberOfDelegators": 22,
          "votingPower": 0,
          "totalVotes": 0,
          "votes1Year": 0,
          "votes6Months": 0,
          "votes3Months": 0,
          "gScoreRank": 1451641
      },
      {
          "rank": 79,
          "delegateAddress": "0x809fa673fe2ab515faa168259cb14e2bedebf68e",
          "ensName": "avsa.eth",
          "numberOfDelegators": 21,
          "votingPower": 2079.0034339580534,
          "totalVotes": 8,
          "votes1Year": 0,
          "votes6Months": 0,
          "votes3Months": 0,
          "gScoreRank": 7922
      },
      {
          "rank": 80,
          "delegateAddress": "0x7b0befc5b043148cd7bd5cfeeef7bc63d28edec0",
          "ensName": "layer3xyz.eth",
          "numberOfDelegators": 21,
          "votingPower": 97.12204160803527,
          "totalVotes": 0,
          "votes1Year": 0,
          "votes6Months": 0,
          "votes3Months": 0,
          "gScoreRank": 24
      },
      {
          "rank": 81,
          "delegateAddress": "0x731501d6f63ce8e8c417a016d340566954f417a0",
          "ensName": null,
          "numberOfDelegators": 21,
          "votingPower": 0,
          "totalVotes": 0,
          "votes1Year": 0,
          "votes6Months": 0,
          "votes3Months": 0,
          "gScoreRank": 2563584
      },
      {
          "rank": 82,
          "delegateAddress": "0x7a45e23cbb7765900f02c54757498bef01c2b18f",
          "ensName": "coday.eth",
          "numberOfDelegators": 20,
          "votingPower": 91317.86730162195,
          "totalVotes": 66,
          "votes1Year": 0,
          "votes6Months": 0,
          "votes3Months": 0,
          "gScoreRank": 67922
      },
      {
          "rank": 83,
          "delegateAddress": "0x3c7676976600c90c8d106786d84bda4369f872a8",
          "ensName": "0x-ql.eth",
          "numberOfDelegators": 19,
          "votingPower": 178.91420336093591,
          "totalVotes": 0,
          "votes1Year": 0,
          "votes6Months": 0,
          "votes3Months": 0,
          "gScoreRank": 37634
      },
      {
          "rank": 84,
          "delegateAddress": "0x393bc37ea5493233d2bdc68fd59dd97ee01b18cf",
          "ensName": "deltajuliet.eth",
          "numberOfDelegators": 18,
          "votingPower": 153910.520213327,
          "totalVotes": 42,
          "votes1Year": 25,
          "votes6Months": 8,
          "votes3Months": 3,
          "gScoreRank": 55798
      },
      {
          "rank": 85,
          "delegateAddress": "0x29ff5a7056d91a3ef8831ce9fd3f00e70a186922",
          "ensName": null,
          "numberOfDelegators": 18,
          "votingPower": 67.64726116075543,
          "totalVotes": 0,
          "votes1Year": 0,
          "votes6Months": 0,
          "votes3Months": 0,
          "gScoreRank": null
      },
      {
          "rank": 86,
          "delegateAddress": "0x13474b3f9f79e08f88148423f336a3e674164e4b",
          "ensName": null,
          "numberOfDelegators": 18,
          "votingPower": 0,
          "totalVotes": 0,
          "votes1Year": 0,
          "votes6Months": 0,
          "votes3Months": 0,
          "gScoreRank": null
      },
      {
          "rank": 87,
          "delegateAddress": "0xb0af3525a236fc06eddc5a2cb6fe725acb0bb45e",
          "ensName": null,
          "numberOfDelegators": 17,
          "votingPower": 0,
          "totalVotes": 0,
          "votes1Year": 0,
          "votes6Months": 0,
          "votes3Months": 0,
          "gScoreRank": 1576222
      },
      {
          "rank": 88,
          "delegateAddress": "0x00de4b13153673bcae2616b67bf822500d325fc3",
          "ensName": "kev.eth",
          "numberOfDelegators": 16,
          "votingPower": 1618379.907220741,
          "totalVotes": 50,
          "votes1Year": 25,
          "votes6Months": 9,
          "votes3Months": 4,
          "gScoreRank": 100576
      },
      {
          "rank": 89,
          "delegateAddress": "0xed625c9aba1245fa8e22eb1f1825881517a9dce7",
          "ensName": null,
          "numberOfDelegators": 16,
          "votingPower": 685.7073,
          "totalVotes": 0,
          "votes1Year": 0,
          "votes6Months": 0,
          "votes3Months": 0,
          "gScoreRank": 4979507
      },
      {
          "rank": 90,
          "delegateAddress": "0x580ba3f7a1fa2793185f80e394cc4e3426b820e1",
          "ensName": "sarahnade.eth",
          "numberOfDelegators": 16,
          "votingPower": 359.146005803361,
          "totalVotes": 8,
          "votes1Year": 0,
          "votes6Months": 0,
          "votes3Months": 0,
          "gScoreRank": 642301
      },
      {
          "rank": 91,
          "delegateAddress": "0x3f60008dfd0efc03f476d9b489d6c5b13b3ebf2c",
          "ensName": "traversa.eth",
          "numberOfDelegators": 16,
          "votingPower": 88.847899999,
          "totalVotes": 23,
          "votes1Year": 0,
          "votes6Months": 0,
          "votes3Months": 0,
          "gScoreRank": 123797
      },
      {
          "rank": 92,
          "delegateAddress": "0x4a5dd203082d5f3404ac316990dd390b817adcdb",
          "ensName": null,
          "numberOfDelegators": 16,
          "votingPower": 0,
          "totalVotes": 0,
          "votes1Year": 0,
          "votes6Months": 0,
          "votes3Months": 0,
          "gScoreRank": null
      },
      {
          "rank": 93,
          "delegateAddress": "0x03b79c0c1487a68aeabd9aa4ce779dad77855f52",
          "ensName": "sinahab.eth",
          "numberOfDelegators": 15,
          "votingPower": 6146.765999999,
          "totalVotes": 0,
          "votes1Year": 0,
          "votes6Months": 0,
          "votes3Months": 0,
          "gScoreRank": 987164
      },
      {
          "rank": 94,
          "delegateAddress": "0xe168954465aa325dadd8510701d56a460859b31a",
          "ensName": "sectorcleaar.eth",
          "numberOfDelegators": 15,
          "votingPower": 217.1836,
          "totalVotes": 1,
          "votes1Year": 0,
          "votes6Months": 0,
          "votes3Months": 0,
          "gScoreRank": 349305
      },
      {
          "rank": 95,
          "delegateAddress": "0x1408004706554d1dd3a998cf07ea91ded30e4ad0",
          "ensName": null,
          "numberOfDelegators": 15,
          "votingPower": 0,
          "totalVotes": 0,
          "votes1Year": 0,
          "votes6Months": 0,
          "votes3Months": 0,
          "gScoreRank": null
      },
      {
          "rank": 96,
          "delegateAddress": "0xd4d00a14d2d3181dbebeaf062933d150e9bafb27",
          "ensName": null,
          "numberOfDelegators": 15,
          "votingPower": 0,
          "totalVotes": 0,
          "votes1Year": 0,
          "votes6Months": 0,
          "votes3Months": 0,
          "gScoreRank": 387141
      },
      {
          "rank": 97,
          "delegateAddress": "0xb62e762af637b49eb4870bce8fe21bfff189e495",
          "ensName": null,
          "numberOfDelegators": 14,
          "votingPower": 31.32812525239846,
          "totalVotes": 40,
          "votes1Year": 1,
          "votes6Months": 0,
          "votes3Months": 0,
          "gScoreRank": 17168
      },
      {
          "rank": 98,
          "delegateAddress": "0x0087a081a9b430fd8f688c6ac5dd24421bfb060d",
          "ensName": "seedlatam.eth",
          "numberOfDelegators": 14,
          "votingPower": 22.7469,
          "totalVotes": 2,
          "votes1Year": 0,
          "votes6Months": 0,
          "votes3Months": 0,
          "gScoreRank": 320057
      },
      {
          "rank": 99,
          "delegateAddress": "0x8477981dbd957ae4c6a249544e43915218948404",
          "ensName": "iopen.eth",
          "numberOfDelegators": 13,
          "votingPower": 340.79418272586753,
          "totalVotes": 19,
          "votes1Year": 0,
          "votes6Months": 0,
          "votes3Months": 0,
          "gScoreRank": 34210
      },
      {
          "rank": 100,
          "delegateAddress": "0x7ccde67aed1fc0ba2a38ea8eca96ab28b1902360",
          "ensName": "passport.jkd.eth",
          "numberOfDelegators": 13,
          "votingPower": 39.7434824865075,
          "totalVotes": 28,
          "votes1Year": 0,
          "votes6Months": 0,
          "votes3Months": 0,
          "gScoreRank": 499644
      }
  ],
  "lastUpdate": "Tue Sep 30 2025",
  "delegatesType": "governor"
}